module.exports = __webpack_public_path__ + "static/media/gallery01.a98c5ab6.png";